import { render, staticRenderFns } from "./In.vue?vue&type=template&id=32367afc"
import script from "./In.vue?vue&type=script&lang=ts"
export * from "./In.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports